/**
 * Стратегії для текстових полів: String, Number, Textarea, Password, Masked
 */

import type { IFieldConfig } from '@/Core/Contracts/UI/Form'
import type { IFieldInputStrategy } from '@/Core/Contracts/UI/IFieldInputStrategy'
import { NumberInput } from '../Inputs/NumberInput'
import { PasswordInput } from '../Inputs/PasswordInput'
import { StringInput } from '../Inputs/StringInput'
import { TextareaInput } from '../Inputs/TextareaInput'
import { BaseFieldInputStrategy } from './BaseFieldInputStrategy'

/**
 * Стратегія для String поля
 */
export class StringFieldStrategy extends BaseFieldInputStrategy implements IFieldInputStrategy {
    getType(): string {
        return 'string'
    }

    getInputComponent(fieldConfig: IFieldConfig): React.ComponentType<any> {
        return StringInput
    }

    transformInputProps(fieldConfig: IFieldConfig): Record<string, any> {
        return {
            placeholder: fieldConfig.placeholder,
            maxLength: fieldConfig.maxLength,
            disabled: fieldConfig.disabled,
            readOnly: fieldConfig.readOnly,
            ...fieldConfig.inputProps,
        }
    }
}

/**
 * Стратегія для Number поля
 */
export class NumberFieldStrategy extends BaseFieldInputStrategy implements IFieldInputStrategy {
    getType(): string {
        return 'number'
    }

    getInputComponent(fieldConfig: IFieldConfig): React.ComponentType<any> {
        return NumberInput
    }

    transformInputProps(fieldConfig: IFieldConfig): Record<string, any> {
        return {
            placeholder: fieldConfig.placeholder,
            min: fieldConfig.min,
            max: fieldConfig.max,
            step: fieldConfig.step,
            disabled: fieldConfig.disabled,
            readOnly: fieldConfig.readOnly,
            ...fieldConfig.inputProps,
        }
    }
}

/**
 * Стратегія для Textarea поля
 */
export class TextareaFieldStrategy extends BaseFieldInputStrategy implements IFieldInputStrategy {
    getType(): string {
        return 'textarea'
    }

    getInputComponent(fieldConfig: IFieldConfig): React.ComponentType<any> {
        return TextareaInput
    }

    transformInputProps(fieldConfig: IFieldConfig): Record<string, any> {
        return {
            placeholder: fieldConfig.placeholder,
            rows: fieldConfig.rows || 4,
            maxLength: fieldConfig.maxLength,
            disabled: fieldConfig.disabled,
            readOnly: fieldConfig.readOnly,
            ...fieldConfig.inputProps,
        }
    }
}

/**
 * Стратегія для Password поля
 */
export class PasswordFieldStrategy extends BaseFieldInputStrategy implements IFieldInputStrategy {
    getType(): string {
        return 'password'
    }

    getInputComponent(fieldConfig: IFieldConfig): React.ComponentType<any> {
        return PasswordInput
    }

    transformInputProps(fieldConfig: IFieldConfig): Record<string, any> {
        return {
            placeholder: fieldConfig.placeholder,
            disabled: fieldConfig.disabled,
            ...fieldConfig.inputProps,
        }
    }
}
